import { confirmDialog } from "primereact/confirmdialog";
import { createProject, deleteProject, updateProject, getAllProjects } from "../../services/ValitanApiService";
import { enqueueSnackbar } from "notistack";

// Fetch Projects
export const getProjects = async (page = 0, size = 10) => {
  try {
    const response = await getAllProjects(page, size);
    if (response.status === 200) {
      return {
        projects: response.data.content,
        paginationInfo: {
          totalElements: response.data.total_elements,
          totalPages: response.data.total_pages,
          pageNumber: response.data.number,
          pageSize: response.data.size,
          sort: response.data.sort,
        },
      };
    } else {
      enqueueSnackbar(response.data.message || "Failed to fetch projects.", { variant: "error" });
      return { projects: [], paginationInfo: {} };
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
    enqueueSnackbar("Error fetching projects. Please try again.", { variant: "error" });
    return { projects: [], paginationInfo: {} };
  }
};

// Delete Project
export const deleteAProject = async (id, loadProjects) => {
  try {
    const response = await deleteProject(id);
    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      await loadProjects();
    } else {
      enqueueSnackbar(response.data.message || "Failed to delete project.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Failed to delete project. Please try again.", { variant: "error" });
    console.error(error);
  }
};

export const confirmDelete = (id, loadProjects) => {
  confirmDialog({
    message: "Are you sure you want to delete this project?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteAProject(id, loadProjects),
    reject: () => { },
  });
};

// Validation on create or update
export const validateProjectForm = (
  projectName,
  selectedProjectCategory,
  selectedCouncil,
  selectedCompany,
  selectedClient,
  setErrors
) => {
  let valid = true;
  const errorsCopy = { projectName: "", projectCategory: "", council: "", company: "", client: "" };

  if (!projectName.trim()) {
    errorsCopy.projectName = "Project Name is required";
    valid = false;
  }
  if (!selectedProjectCategory?.value) {
    errorsCopy.projectCategory = "Project category is required";
    valid = false;
  }
  if (!selectedCouncil?.value) {
    errorsCopy.council = "Council is required";
    valid = false;
  }
  if (!selectedCompany?.value) {
    errorsCopy.company = "Company is required";
    valid = false;
  }
  if (!selectedClient?.value) {
    errorsCopy.client = "Client is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};

// Create or update project
export const createOrUpdateProject = async (
  event,
  projectName,
  selectedProjectCategory,
  selectedCouncil,
  selectedCompany,
  selectedClient,
  editingProjectId,
  loadProjects,
  toggleModal,
  setErrors,
  description,
  code,
  projectValue,
  populationHousehold,
  startDate,
  endDate,
  status
) => {
  event.preventDefault();

  if (!validateProjectForm(projectName, selectedProjectCategory, selectedCouncil, selectedCompany, selectedClient, setErrors)) {
    return;
  }

  const projectData = {
    name: projectName,
    description,
    code,
    project_value: parseFloat(projectValue || 0),
    population_household: parseInt(populationHousehold || 0),
    start_date: startDate,
    end_date: endDate,
    status,
    projectCategory: { id: selectedProjectCategory.value },
    council: { id: selectedCouncil.value },
    company: { id: selectedCompany.value },
    client: { id: selectedClient.value },
  };

  try {
    const response = editingProjectId
      ? await updateProject(editingProjectId, projectData)
      : await createProject(projectData);

    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      toggleModal();
      await loadProjects();
    } else {
      enqueueSnackbar(response.data.message || "Failed to save project data.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error saving project data:", error);
    enqueueSnackbar("Error saving project data. Please try again.", { variant: "error" });
  }
};
